import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SplashScreenService } from 'src/app/_shared/core/services/splash-screen.service';
import { BRANDING_MEDIA } from '../../core/constants/branding.constants';

@Component({
  selector: 'sc-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  @ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;

  brandingMedia: any = BRANDING_MEDIA;

  constructor(
    private el: ElementRef,
    private splashScreenService: SplashScreenService
  ) {}

  ngOnInit(): void {
    this.splashScreenService.init(this.splashScreen);
  }

}
